import React from 'react';
import { DatePicker, ConfigProvider } from 'antd';
import moment from 'moment'
import en from 'antd/es/date-picker/locale/en_US';
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';

dayjs.extend(updateLocale);

// Customize the day names
dayjs.updateLocale('en', {
    weekdaysMin: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
});

// Component level locale
const customLocale = {
    ...en,
    lang: {
        ...en.lang,
        weekdaysMin: dayjs.weekdaysMin(),
        weekdaysShort: dayjs.weekdaysShort(),
    },
};


//ui-cmd-5
const dateFormat = "DD-MMM-YYYY";

const DateInput = ({ value, name, onInputChange, dtFormat = dateFormat, minDate = null, maxDate = null }) => {

    const onChangeDate = (value) => {
        onInputChange(value, name);
    }

    const disableFutureDates = (current) => {
        return current && current > moment().endOf('day');
    };

    return (
        <div>
            <DatePicker
                value={value}
                onChange={onChangeDate}
                format={dtFormat}
                disabledDate={disableFutureDates}
                locale={customLocale}
                minDate={minDate}
                removeIcon={false}
                maxDate={maxDate}
            />
        </div>
    );
}

export default DateInput;
